const sensors = {
    battery_voltage: String("Battery voltage"),
    soil_1_meter: String("15cm soil probe"),
    soil_2_meter: String("30cm soil probe"),
    soil_3_meter: String("45cm soil probe"),
    leaf_meter: String("Moisture in leaf"),
    hum_meter: String("Relative Humidity"),
    temp_meter: String("Temperature"),
    rain_meter: String("Rainfall"),
    gauge_meter: String("Flowmeter"),
};

export default sensors;